<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Businesses of All Sizes</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Unlock the full potential of your business with LocalScale, your comprehensive solution for targeted advertising tailored to businesses of all sizes</p>
                        <p>Whether you're a small startup, a mid-sized company, or a large corporation, LocalScale can help you enhance your local visibility, attract new customers, and drive growth in your target markets.</p>
                        <p>Our precision-targeted ad network allows you to reach your ideal audience based on location targeting, ensuring that your marketing efforts resonate with potential customers.</p>
                        <p>Whether you're a local restaurant, a boutique retail store, a professional service provider, or any other type of business, LocalScale empowers you to stand out from the competition and connect with your target audience effectively.</p>
                        <p>Let us help you achieve your business goals and take your success to new heights with LocalScale.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-more.png" alt="More">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been a game-changer for our business. Their targeted advertising solutions have allowed us to reach our target audience with precision and drive meaningful engagement. Thanks to LocalScale, we've seen a significant increase in brand visibility and customer inquiries, helping us grow our business and expand our reach.”</h3>
                    <p class="testimonial-customer">– Sarah Johnson, Owner of Sarah's Boutique</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>
    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
